import React, { FC, ReactElement } from 'react';
import { Route } from 'react-router';

import {
  GetActiveClientByAttrComponent,
  ClientStatus,
  UniqueClientKey,
  QueryGetActiveClientByAttrArgs,
} from 'api/public';
import { NoClient, QueryManager } from 'components';
import { getSubdomain, isRoot } from 'utilities';

import ClientContext from './Context';

interface IProps {
  children: ReactElement;
}

const PublicProvider: FC<IProps> = ({ children }) => {
  if (isRoot()) {
    return children;
  }

  const variables: QueryGetActiveClientByAttrArgs = {
    key: UniqueClientKey.Subdomain,
    value: getSubdomain(),
  };

  return (
    <GetActiveClientByAttrComponent variables={variables}>
      {props => (
        <QueryManager {...props}>
          {({ data }) => {
            if (!data) {
              return null;
            }

            if (!data.getActiveClientByAttr) {
              return <Route component={NoClient} />;
            }

            const { getActiveClientByAttr } = data;
            const isValidClient = getActiveClientByAttr.client_status !== ClientStatus.Disabled;

            if (!isValidClient) {
              return <Route component={NoClient} />;
            }

            return (
              <ClientContext.Provider value={{ client: { ...getActiveClientByAttr } }}>
                {children}
              </ClientContext.Provider>
            );
          }}
        </QueryManager>
      )}
    </GetActiveClientByAttrComponent>
  );
};

export default PublicProvider;
